/**
 * Flips input boolean value.
 * @param value A boolean.
 */
export default function toogle(value: boolean): boolean {
  return !value;
}
